import React from 'react';
export function Footer() {
  return <footer className="w-full bg-forest-dark text-white/80" data-id="element-59" data-mp="32wd2cf6gdjt0">
      <div className="mx-auto max-w-7xl px-5 py-6 text-center text-xs text-white/50 lg:px-8" data-id="element-60" data-mp="3gfivmltl4hfp">
        © {new Date().getFullYear()} Brightwood Club. All rights reserved.
      </div>
    </footer>;
}